import { BankOutlined, CalendarOutlined, DeleteOutlined, DollarOutlined, EditOutlined, EnvironmentOutlined, HomeOutlined, IdcardOutlined, MedicineBoxOutlined, MoreOutlined, PhoneOutlined, TeamOutlined, UserOutlined, UserAddOutlined, ApartmentOutlined, FileTextOutlined, MailOutlined } from '@ant-design/icons';
import { Avatar, Button, Card, Col, Descriptions, Divider, Dropdown, Menu, Modal, Row, Space, Table, Tabs, Tag, Typography } from 'antd';
import PropTypes from "prop-types";
import React, { useEffect, useState } from 'react'
import AddAyantDroit from './AddAyantDroit';
import { toast } from 'react-toastify';
import axiosInstance from '../../../../../variables/api/axiosInstance';
import AddRepresentant from './AddRepresentant';
const { Title, Text, Paragraph } = Typography;

const DetailsVictime = (props) => {
    const { open, victime, setVictime, setOpen } = props;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isAyantDroitModalVisible, setIsAyantDroitModalVisible] = useState(false);
    const [selectedAyantDroit, setSelectedAyantDroit] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [isRepresentantModalVisible, setIsRepresentantModalVisible] = useState(false);
    const [selectedRepresentant, setSelectedRepresentant] = useState({});


    const handleClose = () => {
        setIsModalVisible(false);
    };
    useEffect(() => {
        setIsModalVisible(open)
    }, [open])

    useEffect(() => {
        if (!isModalVisible) {
            setOpen(false)
        }
    }, [isModalVisible]);

    const formatCurrency = (value) => {
        return value ? `${new Intl.NumberFormat('de-DE').format(value)} FCFA` : '0 FCFA';
    };

    const InfoItem = ({ icon, label, value, color }) => (
        <div style={{ marginBottom: '16px' }}>
            <Space>
                {icon && <span style={{ color: color || '#667eea', fontSize: '18px' }}>{icon}</span>}
                <div>
                    <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
                        {label}
                    </Text>
                    <Text strong style={{ fontSize: '14px' }}>
                        {value || 'Non renseigné'}
                    </Text>
                </div>
            </Space>
        </div>
    );

    const handleEditAyantDroit = (record) => {
        setSelectedAyantDroit(record);
        setEditMode(true);
        setIsAyantDroitModalVisible(true);
    };

    const handleAddRepresentant = () => {
        setIsRepresentantModalVisible(true);
    };

    const handleEditRepresentant = () => {
        setSelectedRepresentant(victime.representant);
        setEditMode(true);
        setIsRepresentantModalVisible(true);
    };

    const handleDeleteRepresentant = () => {
        Modal.confirm({
            title: 'Suppression du représentant',
            content: (
                <>
                    Êtes-vous sûr de vouloir supprimer le représentant :
                    <strong> {victime?.representant?.nom} {victime?.representant?.prenom}</strong> ?
                </>
            ),
            okText: 'Supprimer',
            okType: 'danger',
            cancelText: 'Annuler',
            onOk: async () => {
                let rep = victime?.representant;
                rep.victime = victime.codeId;
                console.log('Deleting représentant:', rep);
                axiosInstance.put(`/api/victime/representant-delete`, rep)
                    .then(() => {
                        toast.success('Représentant supprimé avec succès');
                        // Optional: refresh local state
                        setVictime(prev => ({
                            ...prev,
                            representant: null,
                        }));
                    })
                    .catch((error) => {
                        console.error('Erreur lors de la suppression du représentant : ', error);
                        toast.error("Échec de la suppression du représentant");
                    });
            },
        });
    };

    const actionMenu = (record) => (
        <Menu
            items={[
                {
                    key: 'edit',
                    icon: <EditOutlined />,
                    label: 'Modifier',
                    onClick: () => handleEditAyantDroit(record),
                },
                {
                    key: 'delete',
                    icon: <DeleteOutlined />,
                    label: 'Supprimer',
                    danger: true,
                    onClick: () => handleDeleteAyantDroit(record),
                },
            ]}
        />
    );


    const columnsAyantsDroit = [
        { title: 'Nom', dataIndex: 'nom', key: 'nom', },
        { title: 'Prénoms', dataIndex: 'prenom', key: 'prenom', },
        { title: 'Date de naissance', dataIndex: 'dateNaissance', key: 'dateNaissance', },
        {
            title: 'Qualité', dataIndex: 'qualite', key: 'qualite', render: (text, record) =>
            (<>
                <Tag color='orange'>{text}</Tag> {record?.typeOrphelin ? <Tag color='cyan'>{record?.typeOrphelin}</Tag> : null}
            </>)
        },
        {
            title: 'Actions',
            key: 'actions',
            align: 'center',
            render: (_, record) => (
                <Dropdown overlay={actionMenu(record)} trigger={['click']}>
                    <Button type="text" icon={<MoreOutlined />} />
                </Dropdown>
            ),
        },
    ];

    const handleDeleteAyantDroit = (ayantDroit) => {
        Modal.confirm({
            title: 'Suppression de l\'ayant droit',
            content: (
                <>
                    Êtes-vous sûr de vouloir supprimer l'ayant droit :
                    <strong> {ayantDroit.nom} {ayantDroit.prenom}</strong> ?
                </>
            ),
            okText: 'Supprimer',
            okType: 'danger',
            cancelText: 'Annuler',
            onOk: async () => {
                console.log('Deleting ayant droit:', ayantDroit);
                ayantDroit.victime = victime.codeId;
                axiosInstance.put(`/api/victime/ayant-droit-delete`, ayantDroit)
                    .then(() => {
                        toast.success('Ayant droit supprimé avec succès');
                        // Optional: refresh local state
                        setVictime(prev => ({
                            ...prev,
                            ayantsDroit: prev.ayantsDroit.filter(ad => ad.codeId !== ayantDroit.codeId),
                        }));
                    })
                    .catch((error) => {
                        console.error('Erreur lors de la suppression de l\'ayant droit : ', error);
                        toast.error("Échec de la suppression de l'ayant droit");
                    });
            },
        });
    };


    const tabItems = [
        {
            key: '1',
            label: (
                <span>
                    <IdcardOutlined /> Informations personnelles
                </span>
            ),
            children: (
                <div style={{ padding: '24px 0' }}>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<UserOutlined />}
                                label="Nom complet"
                                value={
                                    victime?.personne?.prenom
                                        ? ` ${victime?.personne?.genre?.startsWith('M') ? 'M.' : 'Mme.'} ${victime?.personne?.nom} ${victime?.personne?.prenom}`
                                        : `${victime?.personne?.genre?.startsWith('M') ? 'M.' : 'Mme.'} ${victime?.personne?.nom}`
                                }
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<UserOutlined />}
                                label="Sexe"
                                value={
                                    <Tag color={victime?.personne?.genre === 'MASCULIN' ? 'blue' : 'pink'}>
                                        {victime?.personne?.genre}
                                    </Tag>
                                }
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<CalendarOutlined />}
                                label="Date de naissance"
                                value={victime?.personne?.dateNaissance}
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<EnvironmentOutlined />}
                                label="Lieu de naissance"
                                value={victime?.personne?.lieuNaissance}
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<PhoneOutlined />}
                                label="Téléphone"
                                value={victime?.personne?.contact?.[0]}
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<HomeOutlined />}
                                label="Pays de résidence"
                                value={victime?.paysResidenceHabituel}
                            />
                        </Col>
                        <Col xs={24}>
                            <InfoItem
                                icon={<HomeOutlined />}
                                label="Adresse"
                                value={victime?.personne?.adresse}
                            />
                        </Col>
                    </Row>
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <span>
                    <MedicineBoxOutlined /> Informations médicales
                </span>
            ),
            children: (
                <div style={{ padding: '24px 0' }}>
                    <Card
                        style={{
                            background: victime?.blesseSinistre
                                ? 'linear-gradient(135deg, #fff5e6 0%, #ffe7ba 100%)'
                                : 'linear-gradient(135deg, #ffe6e6 0%, #ffcccc 100%)',
                            border: 'none',
                            marginBottom: '24px'
                        }}
                    >
                        <Space direction="vertical" size="small">
                            <Text type="secondary">Statut de la victime</Text>
                            <Tag
                                color={victime?.blesseSinistre ? 'volcano' : 'red'}
                                style={{ fontSize: '16px', padding: '8px 16px' }}
                            >
                                {victime?.blesseSinistre ? 'Victime Blessée' : 'Victime Décédée'}
                            </Tag>
                        </Space>
                    </Card>

                    <Row gutter={[24, 24]}>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<CalendarOutlined />}
                                label="Date de consolidation"
                                value={victime?.dateConsolidation}
                            />
                        </Col>
                        <Col xs={24}>
                            <div style={{ marginBottom: '16px' }}>
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <Text type="secondary" style={{ fontSize: '12px' }}>
                                        <MedicineBoxOutlined style={{ marginRight: '8px', color: '#667eea' }} />
                                        Description des dommages
                                    </Text>
                                    <Card size="small" style={{ background: '#f5f7fa' }}>
                                        <Paragraph style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                                            {victime?.descriptionDegatsVictime || 'Aucune description fournie'}
                                        </Paragraph>
                                    </Card>
                                </Space>
                            </div>
                        </Col>
                    </Row>
                </div>
            ),
        },
        {
            key: '3',
            label: (
                <span>
                    <BankOutlined /> Informations professionnelles
                </span>
            ),
            children: (
                <div style={{ padding: '24px 0' }}>
                    <Row gutter={[24, 24]}>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<IdcardOutlined />}
                                label="Profession"
                                value={victime?.personne?.profession}
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<HomeOutlined />}
                                label="Adresse de l'employeur"
                                value={victime?.adresseEmployeur}
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<DollarOutlined />}
                                label="Revenu mensuel avant accident"
                                value={formatCurrency(victime?.revenuProfessionelMensuelAvantAccident)}
                                color="#52c41a"
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<DollarOutlined />}
                                label="Perte de revenu après accident"
                                value={formatCurrency(victime?.perteRevenuProfessionelMensuelApresAccident)}
                                color="#ff4d4f"
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<DollarOutlined />}
                                label="Bourse mensuelle"
                                value={formatCurrency(victime?.montantBourseMensuelle)}
                                color="#1890ff"
                            />
                        </Col>
                        <Col xs={24} md={12}>
                            <InfoItem
                                icon={<CalendarOutlined />}
                                label="Date du dernier salaire"
                                value={victime?.dateDernierSalaire}
                            />
                        </Col>
                        <Col xs={24}>
                            <div style={{ marginBottom: '16px' }}>
                                <Space>
                                    <DollarOutlined style={{ color: '#667eea', fontSize: '18px' }} />
                                    <div>
                                        <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
                                            Salaire perçu pendant le traitement
                                        </Text>
                                        <Tag
                                            color={victime?.perceptionSalairePendantTraitement ? 'green' : 'red'}
                                            style={{ marginTop: '4px' }}
                                        >
                                            {victime?.perceptionSalairePendantTraitement ? 'Oui' : 'Non'}
                                        </Tag>
                                    </div>
                                </Space>
                            </div>
                        </Col>
                    </Row>
                </div>
            ),
        },
    ];

    // Onglet Représentant
    if (victime?.representant) {
        const rep = victime.representant;
        const isMorale = rep?.typePersonne === 'MORALE';

        tabItems.push({
            key: '4',
            label: (
                <span>
                    <UserAddOutlined /> Représentant
                </span>
            ),
            children: (
                <div style={{ padding: '24px 0' }}>

                    {/* ── En-tête ─────────────────────────────────────────────── */}
                    <Card
                        style={{
                            background: isMorale
                                ? 'linear-gradient(135deg, #f0f5ff 0%, #d6e4ff 100%)'
                                : 'linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)',
                            border: 'none',
                            marginBottom: '24px',
                        }}
                    >
                        <Space direction="vertical" size="small" style={{ width: '100%' }}>
                            <Space size="small">
                                <Tag color={isMorale ? 'geekblue' : 'cyan'}>
                                    {isMorale ? 'Personne morale' : 'Personne physique'}
                                </Tag>
                                <Text type="secondary">
                                    {victime?.blesseSinistre
                                        ? 'Représentant de la victime'
                                        : 'Représentant des ayants droit'}
                                </Text>
                            </Space>

                            {isMorale ? (
                                // Raison sociale + type de structure
                                <Space align="baseline" wrap>
                                    <Title level={4} style={{ margin: '8px 0' }}>
                                        {rep.nom}
                                    </Title>
                                    {rep.typePersonneMorale && (
                                        <Tag color="blue">{rep.typePersonneMorale}</Tag>
                                    )}
                                </Space>
                            ) : (
                                // Civilité + nom prénom
                                <Title level={4} style={{ margin: '8px 0' }}>
                                    {rep.sexe?.startsWith('F') ? 'Mme.' : 'M.'} {rep.nom} {rep.prenom}
                                </Title>
                            )}
                        </Space>
                    </Card>

                    {/* ── Détails ──────────────────────────────────────────────── */}
                    <Row gutter={[24, 24]}>

                        {isMorale ? (
                            // ── Personne MORALE ──────────────────────────────────
                            <>
                                <Col xs={24} md={12}>
                                    <InfoItem
                                        icon={<BankOutlined />}
                                        label="Dénomination sociale"
                                        value={rep.nom}
                                    />
                                </Col>
                                <Col xs={24} md={12}>
                                    <InfoItem
                                        icon={<ApartmentOutlined />}
                                        label="Type de structure"
                                        value={rep.fonction}
                                    />
                                </Col>
                                {rep.numeroRegistreCommerce && (
                                    <Col xs={24} md={12}>
                                        <InfoItem
                                            icon={<FileTextOutlined />}
                                            label="N° RCCM / Immatriculation"
                                            value={rep.numeroRegistreCommerce}
                                        />
                                    </Col>
                                )}
                                <Col xs={24} md={12}>
                                    <InfoItem
                                        icon={<HomeOutlined />}
                                        label="Adresse du siège"
                                        value={rep.adresse}
                                    />
                                </Col>
                                <Col xs={24} md={12}>
                                    <InfoItem
                                        icon={<PhoneOutlined />}
                                        label="Téléphone"
                                        value={rep.telephone}
                                    />
                                </Col>
                                {rep.email && (
                                    <Col xs={24} md={12}>
                                        <InfoItem
                                            icon={<MailOutlined />}
                                            label="Email"
                                            value={rep.email}
                                        />
                                    </Col>
                                )}

                                {/* Personne de contact */}
                                {(rep.prenom || rep.profession) && (
                                    <>
                                        <Col xs={24}>
                                            <Divider orientation="left" style={{ color: '#242166', borderColor: '#d6e4ff' }}>
                                                <UserOutlined /> Personne de contact
                                            </Divider>
                                        </Col>
                                        {rep.prenom && (
                                            <Col xs={24} md={12}>
                                                <InfoItem
                                                    icon={<UserOutlined />}
                                                    label="Nom complet"
                                                    value={rep.prenom}
                                                />
                                            </Col>
                                        )}
                                        {rep.profession && (
                                            <Col xs={24} md={12}>
                                                <InfoItem
                                                    icon={<IdcardOutlined />}
                                                    label="Fonction"
                                                    value={rep.profession}
                                                />
                                            </Col>
                                        )}
                                    </>
                                )}
                            </>
                        ) : (
                            // ── Personne PHYSIQUE ────────────────────────────────
                            <>
                                <Col xs={24} md={12}>
                                    <InfoItem
                                        icon={<UserOutlined />}
                                        label="Nom complet"
                                        value={`${rep.sexe?.startsWith('F') ? 'Mme.' : 'M.'} ${rep.nom} ${rep.prenom || ''}`}
                                    />
                                </Col>
                                <Col xs={24} md={12}>
                                    <InfoItem
                                        icon={<PhoneOutlined />}
                                        label="Téléphone"
                                        value={rep.telephone}
                                    />
                                </Col>
                                <Col xs={24} md={12}>
                                    <InfoItem
                                        icon={<IdcardOutlined />}
                                        label="Profession"
                                        value={rep.profession}
                                    />
                                </Col>
                                <Col xs={24} md={12}>
                                    <InfoItem
                                        icon={<HomeOutlined />}
                                        label="Adresse"
                                        value={rep.adresse}
                                    />
                                </Col>
                                {rep.email && (
                                    <Col xs={24} md={12}>
                                        <InfoItem
                                            icon={<MailOutlined />}
                                            label="Email"
                                            value={rep.email}
                                        />
                                    </Col>
                                )}
                            </>
                        )}
                    </Row>

                    {/* ── Actions ──────────────────────────────────────────────── */}
                    <Space style={{ marginTop: '24px' }}>
                        <Button
                            icon={<EditOutlined />}
                            onClick={() => handleEditRepresentant()}
                        >
                            Modifier
                        </Button>
                        <Button
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => handleDeleteRepresentant()}
                        >
                            Supprimer
                        </Button>
                    </Space>

                </div>
            ),
        });
    }

    // Onglet Ayants droit
    if (victime?.ayantsDroit && victime.ayantsDroit.length > 0) {
        tabItems.push({
            key: '5',
            label: (
                <span>
                    <TeamOutlined /> Ayants droit ({victime.ayantsDroit.length})
                </span>
            ),
            children: (
                <div style={{ padding: '24px 0' }}>
                    <Table
                        columns={columnsAyantsDroit}
                        dataSource={victime.ayantsDroit}
                        rowKey="codeId"
                        pagination={false}
                        style={{ marginTop: '16px' }}
                    />
                    <AddAyantDroit
                        open={isAyantDroitModalVisible}
                        victime={victime}
                        setOpen={setIsAyantDroitModalVisible}
                        ayantDroit={selectedAyantDroit}
                        edit={editMode}
                    />
                </div>
            ),
        });
    }


    return (
        <Modal
            title={"Détails sur la victime"}
            open={isModalVisible}
            onOk={handleClose}
            onCancel={handleClose}
            okText="OK"
            cancelText="Fermer"
            width={"1000px"}
            zIndex={2000}
            footer={[
                // Afficher le bouton seulement si le représentant n'existe pas
                !victime?.representant && (
                    <Button
                        key="representant"
                        type="primary"
                        icon={<UserAddOutlined />}
                        onClick={handleAddRepresentant}
                        style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            border: 'none',
                            marginRight: 'auto'
                        }}
                    >
                        {victime?.blesseSinistre
                            ? 'Ajouter un représentant'
                            : 'Ajouter un représentant des ayants droit'}
                    </Button>
                ),
                <Button key="close" onClick={handleClose}>
                    Fermer
                </Button>,
                <Button key="ok" type="primary" onClick={handleClose}>
                    OK
                </Button>
            ]}
        >
            <div
                style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    padding: '32px',
                    borderRadius: '8px 8px 0 0',
                    marginBottom: '0'
                }}
            >
                <Space size="large" align="center">
                    <Avatar
                        size={80}
                        src={`https://ui-avatars.com/api/?name=${victime?.personne?.prenom
                            ? `${victime?.personne?.nom}+${victime?.personne?.prenom}`
                            : victime?.personne?.nom || 'V'
                            }&background=fff&color=667eea&size=128&bold=true`}
                        style={{ border: '4px solid white' }}
                    />
                    <div>
                        <Title level={3} style={{ color: 'white', margin: 0 }}>
                            {victime?.personne?.prenom
                                ? `${victime?.personne?.nom} ${victime?.personne?.prenom}`
                                : victime?.personne?.nom || 'Victime'}
                        </Title>
                        <Space style={{ marginTop: '8px' }}>
                            <Tag
                                color={victime?.blesseSinistre ? 'orange' : 'red'}
                                style={{ fontSize: '14px', padding: '4px 12px' }}
                            >
                                {victime?.blesseSinistre ? 'Blessé(e)' : 'Décédé(e)'}
                            </Tag>
                            {victime?.personne?.profession && (
                                <Tag style={{ background: 'rgba(255,255,255,0.3)', color: 'white', border: 'none' }}>
                                    {victime?.personne?.profession}
                                </Tag>
                            )}
                        </Space>
                    </div>
                </Space>
            </div>

            {/* Contenu avec onglets */}
            <div style={{ padding: '24px' }}>
                <Tabs
                    defaultActiveKey="1"
                    items={tabItems}
                    style={{ minHeight: '400px' }}
                />
                <AddRepresentant
                    open={isRepresentantModalVisible}
                    representant={selectedRepresentant}
                    victime={victime}
                    setOpen={setIsRepresentantModalVisible}
                    edit={editMode}
                />
            </div>

        </Modal>
    )
}

DetailsVictime.propTypes = {
    open: PropTypes.bool,
    victime: PropTypes.object,
    edit: PropTypes.bool,
    setOpen: PropTypes.func,
    setVictime: PropTypes.func,
};
export default DetailsVictime